/* eslint-disable */

slideshare_object.toggleSiblings = function (
  tabToShow,
  tabToHide,
  contentToShow,
  contentToHide
) {
  $(tabToShow).show()
  $(tabToHide).hide()
  $(contentToShow).show()
  $(contentToHide).hide()
}

slideshare_object.setupDescriptionBoxToggle = function () {
  var truncateLength = 126
  var $descriptionContainer = $(".slideshow-description-text-wrapper")
  var $descriptionText = $("#slideshow-description-text")
  var $expandButton = $("#js-expand-description")
  var originalHtml = $descriptionText.html()

  $expandButton.click(function () {
    $descriptionContainer.removeClass("truncated")
    $expandButton.hide(0)
  })

  if (originalHtml && originalHtml.length > truncateLength) {
    $descriptionContainer.addClass("truncated")
  }
}

//Array of slideview toolbar objects
slideshare_object.slideviewInteraction = function () {
  this.slideviewInteractionObjects = {};
}

slideshare_object.slideviewInteraction.prototype.hideAll = function (
  tabToSkip
) {
  for (var key in this.slideviewInteractionObjects) {
    if (this.slideviewInteractionObjects.hasOwnProperty(key)) {
      if (key !== tabToSkip) {
        if (this.slideviewInteractionObjects[key].hide) {
          this.slideviewInteractionObjects[key].hide()
        }
      }
    }
  }

  // Hide share modal if it's visible and a different action was specified
  tabToSkip !== "msharing" &&
    $(".modal-share").is(":visible") &&
    $.slideshareEventManager &&
    $.slideshareEventManager.trigger("playershare")
}
